export enum Currency {
    EUR = 'EUR',
    CHF = 'CHF',
    PLN = 'PLN',
    CZK = 'CZK',
}

export interface SpeedCurveConfig {
    enabled: boolean;
    LUXId: string;
}

export interface AppAdjustTracker {
    android: string;
    ios: string;
}
export interface Config {
    aliceCookieRefreshUrl: string;
    speedCurve: SpeedCurveConfig;
    buildPipelineId: string;
    buildVersion: string;
    shopApiBaseUrl: string;
    serverAPITimeoutInMS: number;
    staticHost: string;
    staticCmsHost: string;
    bellaApiBaseUrl: string;
    gtmAccountId: string;
    facebookAppId: string;
    listingPageSize: number;
    currency: Currency;
    countryCode: string;
    languages: { [key: string]: string };
    hrefLangsDomains: { [key: string]: string };
    env: string;
    preconnectUrls: string[];
    shopToClubOverlayId: string;
    hotjarId: string;
    segmentWriteKey: string;
    segmentBaseCDNURL: string;
    lisaBaseUrl: string;
    bobBaseUrl: string;
    links: {
        clubBaseUrl: string;
        url: string;
        facebook: string;
        facebook2: string; // todo: (P100-2025)  once OneFooter is rolled out we can use facebook for it and remove facebook2. Also change in config.
        instagram: string;
        pinterest: string;
        youtube: string;
        apple: string;
        android: string;
        contact: string;
        press: string;
        imprint: string;
        faq: string;
        brands: string;
        agb: string;
        career: string;
        dataProtection: string;
        creditCheckPolicy: string;
        forgotPassword: string;
        home: string;
        cart: string;
        wishList: string;
        looks: string;
        login: string;
        logout: string;
        myAccount: string;
        myWishlist: string;
        myLooks: string;
        myOrders: string;
        myReviews: string;
        myCoupons: string;
        myEditAccount: string;
        myAddress: string;
        myNewsletter: string;
        myNotifications: string;
        respondentContact: string;
        clubReferAFriendPath: string;
        westwingCollection: string;
        helpCenterUrl: string;
        helpCenterContactUrl: string;
        moodboard: string;
        moodboardLandingPage: string;
        singleSignOn: string;
        olapicUgcGallery: string;
        styleHub: string;
        appsPromoPage: string;
    };
    appAdjustTrackers: {
        small: AppAdjustTracker;
        smart: AppAdjustTracker;
        micro: AppAdjustTracker;
    };
    companyData: {
        contactPoint: {
            contactType: string;
        };
        hoursAvailable: {
            dayOfWeek: string[];
        }[];
    };
    availableCountryCodes: {
        de: string;
        at: string;
        it: string;
        ch: string;
        nl: string;
        pl: string;
        es: string;
        fr: string;
        cz: string;
        sk: string;
    };
}

export type Links = keyof Config['links'];

export default {};
